<template>
    <div class="page-view">
        <tab-group></tab-group>
        <div class="section-wrapper">
            <div class="content-section clearfix">
                <!-- 部门架构 -->
                <div class="content-section__item content-section__left">
                    <div class="conent-header">部门架构</div>
                    <div class="conent-body">
                        <div class="item-header">
                            <i class="e6-icon-add_line" @click="handleAddOriganition"></i>
                            <i class="e6-icon-delete_line" @click="handleDeleteOriganition"></i>
                            <i class="e6-icon-refresh_line" @click="handleRefreshOriganition"></i>
                            <el-input class="search-input" clearable placeholder v-model="filterOrganization">
                                <el-button @click="handleFilterOrganization" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </div>
                        <div class="item-body">
                            <el-tree
                                    ref="filterOrganizationTree"
                                    show-checkbox
                                    default-expand-all
                                    node-key="id"
                                    :data="organizations"
                                    :check-strictly="true"
                                    :highlight-current="true"
                                    :expand-on-click-node="false"
                                    @check-change="handleCheckChange"
                                    @node-click="handleNodeClick"
                                    :filter-node-method="filterNode"
                            ></el-tree>
                        </div>
                    </div>
                </div>
                <!-- 部门架构 end -->
                <!-- 部门信息 -->
                <div class="content-section__item content-section__right">
                    <div class="conent-header">{{pageTitle}}</div>
                    <div class="conent-body">
                        <div class="form-wrapper">
                            <e6-form-extend
                                    class="e6-from--column-2"
                                    ref="formExtend"
                                    :formExtend="formExtend"
                                    :inline="true"
                                    label-width="120px"
                            >
                                <template slot-scope="slotForms">
                                    <el-form-item
                                            prop="forms.pOrgId"
                                            :required="false"
                                            label="上级部门"
                                            :rules="parentDepartmentRules"
                                    >
                                        <!-- <el-input v-model="slotForms.forms.pOrgId" placeholder="上级部门" clearable></el-input> -->
                                        <e6-select-pri
                                                @hide="handleHide"
                                                ref="selectTree"
                                                :data="organizations"
                                                :filter="false"
                                                :multiple="false"
                                                :disabled="parentDepartmentDisabled"
                                                placeholder="上级部门"
                                        ></e6-select-pri>
                                    </el-form-item>
                                    <el-form-item
                                            prop="forms.orgName"
                                            label="部门名称"
                                            :rules="[
                      { required: true, message: '请输入部门名称', trigger: ['blur', 'change'] }
                    ]"
                                    >
                                        <el-input v-model="slotForms.forms.orgName" placeholder="部门名称" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.orgCode" label="部门代码">
                                        <el-input v-model="slotForms.forms.orgCode" placeholder="部门代码" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.managerName" label="部门负责人">
                                        <el-input v-model="slotForms.forms.managerName" placeholder="部门负责人" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.managerPhoneNo" label="负责人电话">
                                        <el-input
                                                v-model="slotForms.forms.managerPhoneNo"
                                                placeholder="负责人电话"
                                                clearable
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.linkMan" label="部门联系人">
                                        <el-input v-model="slotForms.forms.linkMan" placeholder="部门联系人" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.linkPhone" label="联系人电话">
                                        <el-input v-model="slotForms.forms.linkPhone" placeholder="联系人电话" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item class="textarea" prop="forms.address" label="地址">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                v-model="slotForms.forms.address"
                                                placeholder="地址"
                                                clearable
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </e6-form-extend>
                        </div>
                    </div>
                </div>
                <!-- 部门信息 end -->
            </div>
            <div class="operate-section">
                <el-button type="primary" @click="handleSubmitForm" :loading="loadingState">保存</el-button>
            </div>
        </div>

        <!-- 删除部门 -->
        <e6-message-box
                :messageBoxVisible.sync="messageBoxVisible"
                @messageBoxSubmit="handleMessageBoxSubmit"
        >
            <div class="batch-delete">确认删除部门？</div>
        </e6-message-box>
        <!-- 删除部门 end -->
    </div>
</template>

<script>
    import {
        FetchGetExtColumn,
        FetchSaveOrganization,
        FetchFindOrganizationDetail,
        FetchDeleteOrganizationByOrgId
    } from "_private/api/systemSetting/organizationManage";
    import {mapGetters, mapActions} from "vuex";
    import {mergeFormExtend, objUpdate} from "_private/utils/merge";
    import TabGroup from "./tabGroup";

    export default {
        components: {
            TabGroup
        },
        data() {
            return {
                loadingState: false,
                messageBoxVisible: false,
                filterOrganization: "",
                editCheckId: "",
                pageType: "1",
                formExtend: {
                    forms: {
                        pOrgId: "",
                        orgName: "",
                        orgCode: "",
                        managerName: "",
                        managerPhoneNo: "",
                        linkMan: "",
                        linkPhone: "",
                        textarea: "",
                        address: ""
                    },
                    extends: []
                },
                parentDepartmentRules: []
            };
        },
        computed: {
            ...mapGetters(["moduleId", "organizations"]),
            pageTitle() {
                const pageTitle = this.pageType === "1" ? "新增部门信息" : "修改部门信息";
                return pageTitle;
            }
        },
        watch: {
            filterOrganization(val) {
                if (this.filterOrganization === "") {
                    this.$refs.filterOrganizationTree.filter(val);
                }
            },
            "formExtend.forms.pOrgId": {
                handler: function (val) {
                    if (val === 0) {
                        this.$refs.selectTree.handleclear();
                        this.parentDepartmentDisabled = true;
                        this.parentDepartmentRules = [];
                    } else {
                        this.parentDepartmentDisabled = false;
                        this.parentDepartmentRules = [
                            {
                                required: true,
                                message: "请输入上级部门",
                                trigger: ["blur", "change"]
                            }
                        ];
                    }
                },
                immediate: true
            }
        },
        created() {
            this.setOrganizationAct();
            this.FetchGetExtColumn({edit: true, moduleId: this.moduleId});
        },
        methods: {
            ...mapActions(["setOrganizationAct"]),
            FetchGetExtColumn(data) {
                FetchGetExtColumn(data)
                    .then(response => {
                        if (response.result && Array.isArray(response.result)) {
                            this.formExtend.extends = response.result;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 新增部门接口
            FetchSaveOrganization(data) {
                FetchSaveOrganization(data)
                    .then(response => {
                        this.submitCallback(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 获取部门数据接口
            FetchFindOrganizationDetail(data) {
                FetchFindOrganizationDetail(data)
                    .then(response => {
                        if (response.result) {
                            this.setOrgId(response.result.pOrgId);
                            objUpdate(this.formExtend.forms, response.result);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 删除部门接口
            FetchDeleteOrganizationByOrgId(data) {
                FetchDeleteOrganizationByOrgId(data)
                    .then(response => {
                        this.deleteCallback(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 删除成功回调函数
            deleteCallback(data) {
                let type = data.code === 1 ? "success" : "error";
                let message = data.message;
                this.$message({
                    showClose: true,
                    message: message,
                    type: type,
                    duration: 1500,
                    onClose: () => {
                        if (type === "success") {
                            this.cancelOrganization();
                        }
                    }
                });
            },
            // 获取选中的部门 id
            getCheckedNodes() {
                let orgIds = this.$refs.filterOrganizationTree.getCheckedNodes();
                return orgIds.length < 1 ? "" : orgIds[0].id;
            },
            // 获取部门数据
            getOrganization(id) {
                this.pageType = "2";
                this.FetchFindOrganizationDetail({orgId: id});
            },
            // 清除部门数据
            cancelOrganization() {
                this.pageType = "1";
                this.$refs.formExtend.resetForm();
                this.$refs.filterOrganizationTree.setCheckedKeys([]);
                this.setOrganizationAct();
                this.$refs.selectTree.handleclear();
            },
            // 过滤部门方法
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            // 提交以后的回调函数
            submitCallback(data) {
                let type = data.code === 1 ? "success" : "error";
                let message = data.message;
                this.$message({
                    showClose: true,
                    message: message,
                    type: type,
                    duration: 1500,
                    onClose: () => {
                        if (type === "success") {
                            this.cancelOrganization();
                            this.$refs.selectTree.handleclear();
                        }
                        this.loadingState = false
                    }
                });
            },
            // 新增部门
            handleAddOriganition() {
                this.cancelOrganization();
            },
            // 删除部门
            handleDeleteOriganition() {
                if (!this.getCheckedNodes()) {
                    this.$message.error("请选择一个部门");
                } else {
                    this.messageBoxVisible = true;
                }
            },
            // 确认删除部门
            handleMessageBoxSubmit() {
                this.FetchDeleteOrganizationByOrgId({orgId: this.getCheckedNodes()});
            },
            // 刷新部门
            handleRefreshOriganition() {
                this.filterOrganization = "";
                this.$refs.filterOrganizationTree.setCheckedKeys([]);
                this.cancelOrganization();
                this.$refs.selectTree.resetChecked();
            },
            // 过滤部门
            handleFilterOrganization() {
                this.$refs.filterOrganizationTree.filter(this.filterOrganization);
            },
            // 选择部门
            handleCheckChange(item, node) {
                if (node === true) {
                    this.pageType = "1";
                    //点击未选中复选框
                    this.editCheckId = item.id;
                    this.$refs.filterOrganizationTree.setCheckedKeys([item.id]);
                    this.getOrganization(item.id);
                    this.FetchGetExtColumn({
                        edit: true,
                        primaryKeyId: item.id,
                        moduleId: this.moduleId
                    });
                } else {
                    if (this.editCheckId === item.id) {
                        this.pageType = "2";
                        this.$refs.filterOrganizationTree.setCheckedKeys([]);
                        this.cancelOrganization();
                    }
                }
            },
            handleNodeClick(item) {
                this.pageType = "2";
                this.editCheckId = item.id;
                // 设置选中的节点
                this.$refs.filterOrganizationTree.setCheckedKeys([item.id]);
                this.getOrganization(item.id); //获取部门数据
                this.FetchGetExtColumn({
                    edit: true,
                    primaryKeyId: item.id,
                    moduleId: this.moduleId
                });
            },
            // 设置部门id
            setOrgId(data) {
                if (data) {
                    this.$refs.selectTree.setCheckedKeys([data]);
                }
            },
            // 获取部门id
            getOrgId() {
                let selected = this.$refs.selectTree.getCheckedNodes();
                selected = selected.map(item => {
                    return item.id;
                });
                return selected.length ? selected.join(",") : "";
            },
            // 部门下拉弹框隐藏回调
            handleHide() {
                this.formExtend.forms.pOrgId = this.getOrgId();
            },
            // 提交
            handleSubmitForm() {
                this.$refs.formExtend.submitForm().then(valid => {
                    let data = {};
                    if (valid) {
                        data = mergeFormExtend(this.formExtend);
                        if (this.pageType === "2") {
                            if (!this.getCheckedNodes())
                                return this.$message.error("最少选择一个部门");
                            data = Object.assign(data, {orgId: this.getCheckedNodes()});
                        }
                        if (data.orgId == data.pOrgId) {
                            return this.$message.error("部门名称请勿与上级部门重复！");
                        }
                        this.loadingState = true;
                        this.FetchSaveOrganization(data);
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .el-form-item {
        width: auto;
    }

    .page-view {
        height: 100%;
    }

    .section-wrapper {
        height: calc(100% - 61px);
        padding: 0 20px;
    }

    .content-section {
        height: calc(100% - 58px);
        .content-section__item {
            height: 100%;
            float: left;
            .conent-header {
                font-size: 16px;
                line-height: 50px;
            }
            .conent-body {
                height: calc(100% - 50px - 20px);
                min-height: 52px;
                border: 1px solid #ccc;
                box-sizing: border-box;
            }
        }
        .content-section__left {
            width: 400px;
            .item-header {
                display: flex;
                align-items: center;
                position: relative;
                height: 50px;
                border-bottom: 1px solid #ccc;
                i {
                    margin-left: 10px;
                    font-size: 20px;
                    cursor: pointer;
                }
                .search-input {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    width: 200px;
                    margin-top: -14px;
                }
            }
            .item-body {
                height: calc(100% - 51px);
                overflow: auto;
            }
        }
        .content-section__right {
            margin-left: 50px;
            width: calc(100% - 450px);
            .conent-body {
                overflow-y: auto;
            }
            .form-wrapper {
                padding-top: 20px;
                .textarea {
                    width: 300px;
                }
                /deep/ .el-textarea {
                    width: 178px;
                }
            }
        }
    }

    .operate-section {
        position: relative;
        background-color: #fff;
        text-align: center;
        .el-button {
            margin: 15px 0;
        }
    }

    .batch-delete {
        line-height: 100px;
        text-align: center;
        background-color: #fff;
    }
</style>
